import { Routes } from '@angular/router';

import { AuthGuard } from './auth/auth.guard';
import { caseIntegrationsRoutes } from './case-integrations/case-integrations-routing';
import { centralBookingRoutes } from './central-booking/central-booking.routing';
import { configurationRoutes } from './configuration/configuration-routing';
import { manageRoutes } from './manage/manage-routing';
import { marketingRoutes } from './marketing/marketing-routing';
import { paymentProcessingRoutes } from './payment-processing/payment-processing.routing';
import { reportsRoutes } from './reports/reports-routing';
import { menuItems } from './shared/models/menus/secured-menu.model';

export const appRoutes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: 'auth',
    loadComponent: () => import('./auth/auth.component').then((m) => m.AuthComponent),
  },
  {
    path: 'home',
    loadComponent: () => import('./home/home.component').then((m) => m.HomeComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'marketing',
    loadComponent: () => import('./marketing/marketing.component').then((m) => m.MarketingComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'configuration',
    loadComponent: () => import('./configuration/configuration.component').then((m) => m.ConfigurationComponent),
    canActivate: [AuthGuard],
    children: configurationRoutes,
  },
  {
    path: 'central-booking',
    loadComponent: () => import('./central-booking/central-booking.component').then((m) => m.CentralBookingComponent),
    canActivate: [AuthGuard],
    data: { menuId: menuItems.CentralBooking },
    children: centralBookingRoutes,
  },
  {
    path: 'reports',
    loadComponent: () => import('./reports/reports.component').then((m) => m.ReportsComponent),
    canActivate: [AuthGuard],
    children: reportsRoutes,
  },
  {
    path: 'case-integrations',
    loadComponent: () =>
      import('./case-integrations/case-integrations.component').then((m) => m.CaseIntegrationsComponent),
    canActivate: [AuthGuard],
    children: caseIntegrationsRoutes,
  },
  {
    path: 'payment-processing',
    loadComponent: () =>
      import('./payment-processing/payment-processing.component').then((m) => m.PaymentProcessingComponent),
    canActivate: [AuthGuard],
    data: { menuId: menuItems.PaymentProcessing },
    children: paymentProcessingRoutes,
  },
  {
    path: 'manage',
    loadComponent: () => import('./manage/manage.component').then((m) => m.ManageComponent),
    canActivate: [AuthGuard],
    children: manageRoutes,
  },
  ...marketingRoutes,
  { path: '**', redirectTo: '/home', pathMatch: 'full' }, // for any other route, redirect to home
];
